import PropTypes from 'prop-types';
import React from 'react';
import {
  ApiUtil,
  Button,
  FAIcon,
  FloatingLabelFormField,
  PaginationModule,
  CopyUtil,
} from 'reactifi';
import {
  Tabs,
  Tab,
  FormGroup,
  Tooltip,
  OverlayTrigger,
  Modal,
  FormControl,
} from 'react-bootstrap';
import $ from 'jquery';
import Loader from 'react-loader';
import i18n from 'lib/utility/i18n';

import { keyTab } from './MediaChooserField';
import FileUploader from './FileUploader';
import { getFileNameFromUrl } from '../playlists/helpers';

class MediaChooser extends React.Component {
  static propTypes = {
    onActiveMediaChange: PropTypes.func,
    onDblClickMedia: PropTypes.func,
    onHandleFormChange: PropTypes.func,
    setActiveTab: PropTypes.func,
    activeTab: PropTypes.number,
    accountId: PropTypes.number,
    pageSize: PropTypes.number,
    searchTimeout: PropTypes.number,
    allowEdit: PropTypes.bool,
    allowDelete: PropTypes.bool,
    contentType: PropTypes.string,
    showFileName: PropTypes.bool,
    acceptExtList: PropTypes.array,
  };

  static defaultProps = {
    pageSize: 8,
    searchTimeout: 300,
    title: 'Select Media',
    allowEdit: false,
    allowDelete: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      mediaUrl: null,
      mediaName: '',
      media_list: [],
      activeMedia: null,
      listLoaded: false,
      searchText: '',
      page: 1,
      totalPages: 1,
      searchDebounced: null,
      showDeleteModal: false,
      errors: [],
      displayError: false,
    };

    this.setMedia = this.setMedia.bind(this);
    this.updateMediaList = this.updateMediaList.bind(this);
    this.setActiveMedia = this.setActiveMedia.bind(this);
    this.clearSearchDebounced = this.clearSearchDebounced.bind(this);
    this.editMedia = this.editMedia.bind(this);
    this.deleteMedia = this.deleteMedia.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
    this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.reloadGalleryWithNewImage = this.reloadGalleryWithNewImage.bind(this);
    this.setError = this.setError.bind(this);
  }

  componentDidMount() {
    this.updateMediaList(this.state.page, this.state.searchText);
  }

  setMedia(uploadedFileUrl, fileName) {
    this.setState({ mediaUrl: uploadedFileUrl, mediaName: fileName });
    this.props.onActiveMediaChange({
      url: uploadedFileUrl,
      name: fileName,
    });
  }

  async updateMediaList(page, searchText) {
    page = page || 1;
    this.clearSearchDebounced();

    this.setState({ listLoaded: false });
    let url = `/api/data/next_media.json?page[number]=${page}&page[size]=${this.props.pageSize}`;

    if (searchText) {
      url += `&query[name][term]=${searchText}&query[name][fields]=name.word_start,description.word_start`;
    }

    if (this.props.accountId) {
      url += `&filter[account_id]=${this.props.accountId}`;
    }

    const payload = await ApiUtil.loadApiData(url, false);
    const media_list = payload.data.map((content) => ({
      id: content.id,
      type: content.type,
      ...content.attributes,
    }));
    const totalPages = Math.ceil(
      payload.meta.total_count / this.props.pageSize
    );
    this.setState({
      media_list,
      listLoaded: true,
      searchText: searchText,
      page: page,
      totalPages,
    });
  }

  setActiveMedia(event) {
    const active_id = parseInt(event.target.id);
    const active_media = this.state.media_list.find(
      (item) => String(item.id) === String(active_id)
    );
    active_media.filename = getFileNameFromUrl(active_media.url);
    if (this.props.showFileName && !active_media.name) {
      try {
        active_media.name = getFileNameFromUrl(active_media.url);
      } catch (e) {
        active_media.name = null;
      }
    }
    this.props.onActiveMediaChange(active_media);
    this.setState({ activeMedia: active_media });
  }

  handleSearchTextChange(event) {
    this.clearSearchDebounced();

    var newSearchText = event.target.value;
    if (this.state.searchText !== newSearchText) {
      this.state.searchDebounced = setTimeout(() => {
        this.updateMediaList(1, newSearchText);
      }, this.props.searchTimeout);
    }
  }

  handleSelectPage(page) {
    this.updateMediaList(page, this.state.searchText);
  }

  editMedia() {
    window.location =
      window.location + '/' + this.state.activeMedia.id + '/edit';
  }

  deleteMedia() {
    this.closeDeleteModal();

    var mediaId = this.state.activeMedia.id;
    $.ajax({
      url: '/admin/media/' + mediaId,
      type: 'DELETE',
      contentType: 'json',
      success: function (result) {
        window.location.reload();
      },
      error: function (result) {
        window.location.reload();
      },
    });
  }

  setActiveTab(selected) {
    this.props.setActiveTab(selected);
  }

  reloadGalleryWithNewImage = () => {
    this.updateMediaList(this.state.totalPages);
    this.setState({ mediaUrl: null, mediaName: '', activeMedia: null });
  };

  openDeleteModal() {
    this.setState({ showDeleteModal: true });
  }

  closeDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  clearSearchDebounced() {
    if (this.state.searchDebounced) {
      clearTimeout(this.state.searchDebounced);
      this.state.searchDebounced = null;
    }
  }

  renderModal() {
    var mediaName =
      this.state.activeMedia && this.state.activeMedia.name
        ? ' ' + this.state.activeMedia.name
        : '';
    return (
      <Modal show={this.state.showDeleteModal} onHide={this.closeDeleteModal}>
        <Modal.Header>
          <Modal.Title>{i18n.t('Please Confirm')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>Are you sure you want to delete this {mediaName}?</span>
        </Modal.Body>
        <Modal.Footer>
          <Button className="pull-left" onClick={this.closeDeleteModal}>
            {i18n.t('Close')}
          </Button>
          <Button
            className="pull-right"
            bsStyle="primary"
            onClick={this.deleteMedia}
          >
            {i18n.t('Delete')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  setError(error) {
    this.setState({
      errors: [...this.state.errors, error],
      displayError: true,
    });
  }

  renderErrors = () => {
    const errorContent = this.state.errors[0];

    setTimeout(() => {
      this.setState({
        displayError: false,
        errors: []
      });
    }, 4000);

    return (
      <div className="alert alert-danger">{errorContent}</div>
    );
  };

  render() {
    const { accountId, activeTab, onDblClickMedia } = this.props;
    const { activeMedia, mediaName, mediaUrl } = this.state;

    var activeMediaProperties = (
      <span className="empty-selection">{i18n.t('None Selected')}</span>
    );

    if (activeMedia) {
      var selectButton;
      var editButton;
      var deleteButton;

      if (this.props.allowEdit) {
        editButton = (
          <Button
            className="pull-left"
            onClick={this.editMedia}
            bsStyle="primary"
          >
            {i18n.t('Edit')}
          </Button>
        );
      }

      if (this.props.allowDelete) {
        deleteButton = (
          <Button
            className="pull-right"
            onClick={this.openDeleteModal}
            bsStyle="primary"
          >
            {i18n.t('Delete')}
          </Button>
        );
      }

      activeMediaProperties = (
        <div id="active-media" className="animated fadeInDown">
          <div>
            <div
              data-object-attribute="name"
              data-object-id={activeMedia.id}
              data-object-type="media"
              className="media-item"
            >
              <span className="media-title">{i18n.t('Name:')} </span>
              <span>{activeMedia.name}</span>
            </div>
            <div
              data-object-attribute="filename"
              data-object-id={activeMedia.id}
              data-object-type="media"
              className="media-item"
            >
              <span className="media-title">{i18n.t('File Name:')} </span>
              <span>{activeMedia.filename}</span>
            </div>
            <div
              data-object-attribute="description"
              data-object-id={activeMedia.id}
              data-object-type="media"
              className="media-item"
            >
              <div className="media-title">{i18n.t('Description:')} </div>
              <span>{activeMedia.description}</span>
            </div>
            <div
              data-object-attribute="fileurl"
              data-object-id={activeMedia.id}
              data-object-type="media"
              className="media-item"
            >
              <span className="media-title">{i18n.t('File Url:')} </span>
              <span>{activeMedia.url}</span>
              <Button
                className="m-l-5"
                cssStyle={{ 'min-height': 22, 'max-height': 22 }}
                data-action="copy-file-url"
                icon="copy"
                onClick={() => CopyUtil.copyText(activeMedia.url)}
                style="link"
              />
            </div>
          </div>
          {selectButton}
          {editButton}
          {deleteButton}
          <div className="clearfix" />
        </div>
      );
    }
    return (
      <div
        className="media-chooser"
        data-object-attribute="media"
        data-object-type="accounts"
        data-object-id={accountId}
      >
        {this.state.errors.length && this.state.displayError
          ? this.renderErrors()
          : null}
        <div className="tabs-container">
          <Tabs
            id="gallery-tabs"
            mountOnEnter={true}
            unmountOnExit={true}
            defaultActiveKey={keyTab.MEDIA}
            activeKey={activeTab}
            onSelect={this.setActiveTab}
          >
            <Tab eventKey={keyTab.MEDIA} title={i18n.t('Media Gallery')}>
              <div className="card-body">
                <div className="row m-t-10">
                  <div className="col-8">
                    <div className="search-wrapper full-width m-b-30">
                      <div className="search-icon">
                        <FAIcon icon="search" />
                      </div>
                      <div className="search-input">
                        <FormGroup controlId="search">
                          <FormControl
                            data-action="search-media"
                            data-object-attribute="media"
                            data-object-type="accounts"
                            data-object-id={accountId}
                            type="text"
                            placeholder={i18n.t('Search media...')}
                            onChange={this.handleSearchTextChange}
                            className="search-media"
                          />
                        </FormGroup>
                      </div>
                    </div>
                    <Loader loaded={this.state.listLoaded} top="75px">
                      {this.state.media_list.map((item, i) => {
                        var name, description;
                        if (item.name || item.description) {
                          if (item.name) {
                            name = (
                              <div>
                                <strong>{item.name}</strong>
                              </div>
                            );
                          }

                          if (item.description) {
                            description = <div>{item.description}</div>;
                          }
                        } else {
                          name = (
                            <div>
                              <i>{i18n.t('No name or description')}</i>
                            </div>
                          );
                        }

                        if (item.description) {
                          description = <div>{item.description}</div>;
                        }

                        const tooltip = (
                          <Tooltip style={{ zIndex: 9999 }}>
                            <div>
                              {name}
                              {description}
                            </div>
                          </Tooltip>
                        );
                        return (
                          <div
                            className={`${
                              activeMedia?.id === item.id
                                ? 'col-md-3 item isActive'
                                : 'col-md-3 item'
                            }`}
                            style={{ height: 75, marginBottom: 15 }}
                            key={item.id}
                          >
                            <OverlayTrigger placement="top" overlay={tooltip}>
                              <div
                                data-attribute="url"
                                data-object-id={item.id}
                                data-object-type="media"
                                id={item.id}
                                key={i}
                                onClick={this.setActiveMedia}
                                onDoubleClick={onDblClickMedia}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  backgroundImage: `url('${item.url}')`,
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'no-repeat',
                                }}
                              />
                            </OverlayTrigger>
                          </div>
                        );
                      })}
                    </Loader>
                  </div>
                  <div className="col-md-4 active-media-col selected-media">
                    <h2 className="mimic-header">{i18n.t('Selected Media')}</h2>
                    <div>{activeMediaProperties}</div>
                  </div>
                  <div className="col-md-12">
                    <PaginationModule
                      activePage={this.state.page}
                      collection={this.state.media_list}
                      collectionMeta={{
                        total_count: this.state.totalPages * 8,
                      }}
                      isBranded={true}
                      pageSize={8}
                      resultsDisplayed={false}
                      setActivePage={this.handleSelectPage}
                    />
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey={keyTab.UPLOAD} title={i18n.t('Upload a File')}>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12 m-b-20">
                    <p>
                      {i18n.t(
                        'Fill in a name and description for this image below for use in alt tags. Click Select to use this image and save it to the media gallery.'
                      )}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <form
                      name="upload-form"
                      onChange={this.props.onHandleFormChange}
                    >
                      <div className="upload-image-form">
                        <FileUploader
                          id="file_uploader"
                          buttonText={i18n.t('Add Image')}
                          buttonType="secondary"
                          showPlusBtn={false}
                          showProgress={false}
                          onSuccessState={this.setMedia}
                          contentType={this.props.contentType}
                          acceptExtList={this.props.acceptExtList}
                          setError={this.setError}
                        />
                        <FloatingLabelFormField
                          name="media_name"
                          caption={i18n.t('Name')}
                        />
                        <FloatingLabelFormField
                          name="media_description"
                          caption={i18n.t('Description')}
                        />
                      </div>
                    </form>
                  </div>
                  <div className="col-md-6">
                    <div
                      className="preview-container"
                      style={{
                        background: mediaUrl ? 'transparent' : '#D9D9D9',
                      }}
                    >
                      <img
                        className="img-fluid"
                        src={mediaUrl}
                        style={{ display: mediaUrl ? 'block' : 'none' }}
                        alt="Media preview"
                      />
                    </div>
                    <div className="preview-name">
                      <span>{i18n.t('Preview:')}&nbsp;</span>{' '}
                      {mediaName ? mediaName : i18n.t('No file')}
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
        {this.props.allowDelete && this.renderModal()}
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => (
  <MediaChooser {...props} ref={ref} />
));
